import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./../style/addlisting.css";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd"; // add Button, Spin

const MAX_IMAGE_MB = 5;
const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

const AddListing = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // Upload states (AntD fileLists)
  const [logoFileList, setLogoFileList] = useState([]);
  const [imagesFileList, setImagesFileList] = useState([]);
  const [preview, setPreview] = useState({ open: false, title: "", src: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    login_id: null,
    business_name: "",
    owner_name: "",
    category: "",
    sub_category: "",
    description: "",
    live_url: "",
    address: {
      email: "",
      contact_1: "",
      contact_2: "",
      url: "",
      street_address_1: "",
      street_address_2: "",
      landmark: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
    social_accounts: {
      facebook_url: "",
      instagram_url: "",
      x_url: "",
      linkedin_url: "",
      youtube_url: "",
      pinterest_url: "",
    },
    business_time: {
      is_24_7: false,
      working_hours: {
        Monday: { open: "", close: "" },
        Tuesday: { open: "", close: "" },
        Wednesday: { open: "", close: "" },
        Thursday: { open: "", close: "" },
        Friday: { open: "", close: "" },
        Saturday: { open: "", close: "" },
        Sunday: { open: "", close: "" },
      },
    },
  });

  const [errors, setErrors] = useState({});
  // const [successMessage, setSuccessMessage] = useState("");

  // Fetch categories
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(
          "https://biz.dropyourbusiness.com/api/categories"
        );
        setCategories(res.data);
      } catch (e) {
        console.error(e);
        toast.error("Failed to load categories. Please try again.");
      }
    })();
  }, []);

  // Fetch countries
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(
          "https://biz.dropyourbusiness.com/api/countries"
        );
        setCountries(Array.isArray(res.data?.data) ? res.data.data : []);
      } catch (e) {
        console.error(e);
        toast.error("Failed to load countries.");
      }
    })();
  }, []);

  const fetchStates = async (countryId) => {
    try {
      const res = await axios.get(
        `https://biz.dropyourbusiness.com/api/states/${countryId}`
      );
      setStates(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) {
      console.error(e);
      setStates([]);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const res = await axios.get(
        `https://biz.dropyourbusiness.com/api/cities/${stateId}`
      );
      setCities(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) {
      console.error(e);
      setCities([]);
    }
  };

  const fetchSubcategories = async (categoryId) => {
    try {
      const res = await axios.get(
        `https://biz.dropyourbusiness.com/api/categories/${categoryId}/subcategories`
      );
      setSubcategories(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error(e);
      setSubcategories([]);
    }
  };
  // Slug from name only
  const slugify = (str) =>
    String(str || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-{2,}/g, "-");

  // --- Availability check ---
  // Try your preferred endpoint first. Fall back to by-slug fetch.
  const slugExists = async (slug) => {
    try {
      // OPTION A: if your backend exposes an EXISTS endpoint (adjust to your real one)
      const r = await axios.get(
        `https://biz.dropyourbusiness.com/api/business/slug/exists`,
        { params: { slug } }
      );
      // Expecting { exists: true/false } shape
      if (typeof r?.data?.exists === "boolean") return r.data.exists;
    } catch (_) {
      // ignore and try option B
    }

    try {
      // OPTION B: if you have by-slug fetch; 200 => exists, 404 => not found
      await axios.get(
        `https://biz.dropyourbusiness.com/api/business/live/${encodeURIComponent(
          slug
        )}`
      );
      return true; // found
    } catch (e) {
      // if 404 or network error treat as not-exist (refine if you need)
      return false;
    }
  };

  // Ensure uniqueness: base, base01, base02, ...
  const ensureUniqueSlug = async (base) => {
    let slug = base;
    let i = 0;
    // hard stop at 99 to avoid infinite loops
    while (await slugExists(slug)) {
      i += 1;
      slug = base + String(i).padStart(2, "0"); // no hyphen, e.g., business-test01
      if (i >= 99) break;
    }
    return slug;
  };

  // Add this useEffect below your other hooks:
  useEffect(() => {
    const base = slugify(formData.business_name);
    setFormData((prev) =>
      prev.live_url === base ? prev : { ...prev, live_url: base }
    );
  }, [formData.business_name]);
  // Handle inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    const [parent, child] = name.split(".");

    if (child) {
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (name === "category") {
      setFormData((prev) => ({ ...prev, sub_category: "" }));
      fetchSubcategories(value);
    }
    if (name === "address.country") {
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, state: "", city: "" },
      }));
      fetchStates(value);
    }
    if (name === "address.state") {
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, city: "" },
      }));
      fetchCities(value);
    }
  };

  // Login id from localStorage
  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed.user?.id) {
          setFormData((prev) => ({ ...prev, login_id: parsed.user.id }));
        }
      } catch (e) {
        console.error("Error parsing stored data:", e);
      }
    }
  }, []);

  // ===== AntD Upload helpers =====
  const beforeUpload = (file) => {
    const isAllowed = ACCEPTED_TYPES.includes(file.type);
    if (!isAllowed) {
      toast.error("Only JPG/PNG/WebP images are allowed.");
      return Upload.LIST_IGNORE;
    }
    const isLtMax = file.size / 1024 / 1024 < MAX_IMAGE_MB;
    if (!isLtMax) {
      toast.error(`Image must be smaller than ${MAX_IMAGE_MB}MB.`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handlePreview = async (file) => {
    setPreview({
      open: true,
      title: file.name || "Preview",
      src: file.url || file.thumbUrl,
    });
  };

  const validateForm = () => {
    const requiredFields = {
      business_name: "Business Name is required",
      owner_name: "Owner Name is required",
      category: "Business Category is required",
      sub_category: "Sub Category is required",
      description: "Business Description is required",
      "address.email": "Email ID is required",
      "address.contact_1": "Contact No 1 is required",
      "address.street_address_1": "Street Address Line 1 is required",
      "address.country": "Country is required",
      "address.state": "State is required",
      "address.city": "City is required",
      "address.pincode": "Pincode is required",
    };

    const newErrors = {};
    Object.entries(requiredFields).forEach(([field, message]) => {
      const [parent, child] = field.split(".");
      const value = child ? formData[parent]?.[child] : formData[field];
      if (!value) newErrors[field] = message;
    });

    // logo check (via fileList)
    if (logoFileList.length === 0 || !logoFileList[0].originFileObj) {
      newErrors.logo = "Business Logo is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // avoid double submit
    if (isSubmitting) return;

    // basic validation
    if (!validateForm()) {
      toast.error("Please fill all required fields.");
      return;
    }

    // ensure we have a logo file
    if (!logoFileList?.[0]?.originFileObj) {
      toast.error("Please upload a logo.");
      return;
    }

    setIsSubmitting(true);
    try {
      const fd = new FormData();
      const baseSlug = slugify(formData.business_name);

      // 2) ensure uniqueness from server
      const finalSlug = await ensureUniqueSlug(baseSlug);

      // Scalars
      fd.append("login_id", formData.login_id ?? "");
      fd.append("business_name", formData.business_name);
      fd.append("owner_name", formData.owner_name);
      fd.append("category", formData.category);
      fd.append("sub_category", formData.sub_category);
      fd.append("description", formData.description);

      // Address (append only defined fields)
      Object.entries(formData.address || {}).forEach(([key, value]) => {
        fd.append(`address[${key}]`, value ?? "");
      });

      // Social Accounts
      Object.entries(formData.social_accounts || {}).forEach(([key, value]) => {
        fd.append(`social_accounts[${key}]`, value ?? "");
      });
      fd.append("live_url", finalSlug);

      // Business Time
      fd.append(
        "business_time[is_24_7]",
        formData.business_time?.is_24_7 ? 1 : 0
      );
      Object.entries(formData.business_time?.working_hours || {}).forEach(
        ([day, times]) => {
          fd.append(
            `business_time[working_hours][${day}][open]`,
            times?.open ?? ""
          );
          fd.append(
            `business_time[working_hours][${day}][close]`,
            times?.close ?? ""
          );
        }
      );

      // Files
      fd.append("logo", logoFileList[0].originFileObj);
      (imagesFileList || []).forEach((f) => {
        if (f.originFileObj) fd.append("images[]", f.originFileObj);
      });

      const response = await axios.post(
        "https://biz.dropyourbusiness.com/api/business/add",
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      toast.success("Business added successfully!");
      const created = response?.data?.business;
      const newId = created?.id;
      if (newId) localStorage.setItem("localbusinessId", String(newId));
      const savedSlug = created?.live_url || finalSlug;

      // Redirect to the pretty URL
      navigate(`/categories/${savedSlug}`);

      // reset UI (keep login id)
      setFormData((prev) => ({
        ...prev,
        business_name: "",
        owner_name: "",
        category: "",
        sub_category: "",
        description: "",
        address: {
          email: "",
          contact_1: "",
          contact_2: "",
          url: "",
          street_address_1: "",
          street_address_2: "",
          landmark: "",
          country: "",
          state: "",
          city: "",
          pincode: "",
        },
        social_accounts: {
          facebook_url: "",
          instagram_url: "",
          x_url: "",
          linkedin_url: "",
          youtube_url: "",
          pinterest_url: "",
        },
        business_time: {
          is_24_7: false,
          working_hours: {
            Monday: { open: "", close: "" },
            Tuesday: { open: "", close: "" },
            Wednesday: { open: "", close: "" },
            Thursday: { open: "", close: "" },
            Friday: { open: "", close: "" },
            Saturday: { open: "", close: "" },
            Sunday: { open: "", close: "" },
          },
        },
      }));
      setLogoFileList([]);
      setImagesFileList([]);
      setErrors({});

      // navigate after a short tick (optional)
      navigate("/business-listing");
    } catch (error) {
      // try to show Laravel validation messages
      const apiErr = error?.response?.data;
      if (apiErr?.errors && typeof apiErr.errors === "object") {
        // flatten and toast each first error
        Object.entries(apiErr.errors).forEach(([field, msgs]) => {
          const msg = Array.isArray(msgs) ? msgs[0] : String(msgs);
          toast.error(`${field}: ${msg}`);
        });
      } else {
        toast.error(
          apiErr?.message || "Failed to add business. Please try again."
        );
      }
      console.error("Error:", apiErr || error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-listing-page">
      <ToastContainer />
      <div className="addlisting-header">
        <h1>Add Business Listing</h1>
        <p>Submit your business details and grow your reach</p>
      </div>

      <form className="add-listing-form" onSubmit={handleSubmit}>
        {/* Business Details */}
        <div className="form-section-general">
          <h2>Business Details</h2>
          <div className="form-group">
            <label htmlFor="business_name">Business Name*</label>
            <input
              type="text"
              id="business_name"
              name="business_name"
              value={formData.business_name}
              onChange={handleChange}
              placeholder="Enter business name"
            />
            {errors.business_name && (
              <p className="error-message">{errors.business_name}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="owner_name">Owner Name*</label>
            <input
              type="text"
              id="owner_name"
              name="owner_name"
              value={formData.owner_name}
              onChange={handleChange}
              placeholder="Enter owner name"
            />
            {errors.owner_name && (
              <p className="error-message">{errors.owner_name}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="category">Category*</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {categories.map((category) => (
                <option key={category.Category_Id} value={category.Category_Id}>
                  {category.Category_Name}
                </option>
              ))}
            </select>
            {errors.category && (
              <p className="error-message">{errors.category}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="sub_category">Sub Category*</label>
            <select
              id="sub_category"
              name="sub_category"
              value={formData.sub_category}
              onChange={handleChange}
              disabled={!subcategories.length}
            >
              <option value="">Select Subcategory</option>
              {subcategories.map((subcategory) => (
                <option
                  key={subcategory.Sub_Category_Id}
                  value={subcategory.Sub_Category_Id}
                >
                  {subcategory.Sub_Category_Name}
                </option>
              ))}
            </select>
            {errors.sub_category && (
              <p className="error-message">{errors.sub_category}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="description">Description*</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter business description"
            />
            {errors.description && (
              <p className="error-message">{errors.description}</p>
            )}
          </div>
        </div>

        {/* Address */}
        <div className="form-section-address">
          <h2>Address Details</h2>
          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input
              type="email"
              id="email"
              name="address.email"
              value={formData.address.email}
              onChange={handleChange}
              placeholder="Enter email"
            />
            {errors["address.email"] && (
              <p className="error-message">{errors["address.email"]}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="contact_1">Primary Contact*</label>
            <input
              type="text"
              id="contact_1"
              name="address.contact_1"
              value={formData.address.contact_1}
              onChange={handleChange}
              placeholder="Enter primary contact number"
            />
            {errors["address.contact_1"] && (
              <p className="error-message">{errors["address.contact_1"]}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="street_address_1">Street Address 1*</label>
            <input
              type="text"
              id="street_address_1"
              name="address.street_address_1"
              value={formData.address.street_address_1}
              onChange={handleChange}
              placeholder="Enter street address 1"
            />
            {errors["address.street_address_1"] && (
              <p className="error-message">
                {errors["address.street_address_1"]}
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Country*</label>
            <select
              name="address.country"
              value={formData.address.country}
              onChange={handleChange}
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>State*</label>
            <select
              name="address.state"
              value={formData.address.state}
              onChange={handleChange}
              disabled={!states.length}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
            {errors["address.state"] && (
              <p className="error-message">{errors["address.state"]}</p>
            )}
          </div>

          <div className="form-group">
            <label>City*</label>
            <select
              name="address.city"
              value={formData.address.city}
              onChange={handleChange}
              disabled={!cities.length}
            >
              <option value="">Select City</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
            {errors["address.city"] && (
              <p className="error-message">{errors["address.city"]}</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="pincode">Pincode*</label>
            <input
              type="text"
              id="pincode"
              name="address.pincode"
              value={formData.address.pincode}
              onChange={handleChange}
              placeholder="Enter pincode"
            />
            {errors["address.pincode"] && (
              <p className="error-message">{errors["address.pincode"]}</p>
            )}
          </div>
        </div>

        {/* Logo + Images */}
        <div className="form-section-images">
          <h2>Logo & Images</h2>

          {/* Logo (single) */}
          <div className="form-group">
            <label>Upload Logo* (1 image)</label>
            <Upload
              name="file"
              listType="picture-card"
              fileList={logoFileList}
              beforeUpload={beforeUpload}
              // IMPORTANT: do not auto-upload
              customRequest={() => false}
              onChange={({ fileList }) => setLogoFileList(fileList.slice(-1))}
              onPreview={handlePreview}
              maxCount={1}
              accept={ACCEPTED_TYPES.join(",")}
            >
              {logoFileList.length >= 1 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
            {errors.logo && <p className="error-message">{errors.logo}</p>}
          </div>

          {/* Images (multiple) */}
          <div className="form-group">
            <label>Upload Images (multiple)</label>
            <Upload
              name="file"
              listType="picture-card"
              multiple
              fileList={imagesFileList}
              beforeUpload={beforeUpload}
              // IMPORTANT: do not auto-upload
              customRequest={() => false}
              onChange={({ fileList }) => setImagesFileList(fileList)}
              onPreview={handlePreview}
              accept={ACCEPTED_TYPES.join(",")}
            >
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </div>

          <Modal
            open={preview.open}
            title={preview.title}
            footer={null}
            onCancel={() => setPreview((p) => ({ ...p, open: false }))}
          >
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img
              alt="preview image"
              style={{ width: "100%" }}
              src={preview.src}
            />
          </Modal>
        </div>

        {/* Social */}
        <div className="form-section-social">
          <h2>Social Account</h2>
          <div className="social-accounts-grid">
            <div className="form-group">
              <label htmlFor="facebook_url">
                <FaFacebook style={{ marginRight: "8px", color: "#3b5998" }} />
                Facebook URL
              </label>
              <input
                type="url"
                id="facebook_url"
                name="social_accounts.facebook_url"
                value={formData.social_accounts.facebook_url}
                onChange={handleChange}
                placeholder="Enter Facebook URL"
              />
            </div>

            <div className="form-group">
              <label htmlFor="linkedin_url">
                <FaLinkedin style={{ marginRight: "8px", color: "#0077B5" }} />
                LinkedIn URL
              </label>
              <input
                type="url"
                id="linkedin_url"
                name="social_accounts.linkedin_url"
                value={formData.social_accounts.linkedin_url}
                onChange={handleChange}
                placeholder="Enter LinkedIn URL"
              />
            </div>

            <div className="form-group">
              <label htmlFor="x_url">
                <FaXTwitter style={{ marginRight: "8px", color: "#000" }} />X
                URL
              </label>
              <input
                type="url"
                id="x_url"
                name="social_accounts.x_url"
                value={formData.social_accounts.x_url}
                onChange={handleChange}
                placeholder="Enter Twitter URL"
              />
            </div>

            <div className="form-group">
              <label htmlFor="instagram_url">
                <FaInstagram style={{ marginRight: "8px", color: "#E4405F" }} />
                Instagram URL
              </label>
              <input
                type="url"
                id="instagram_url"
                name="social_accounts.instagram_url"
                value={formData.social_accounts.instagram_url}
                onChange={handleChange}
                placeholder="Enter Instagram URL"
              />
            </div>

            <div className="form-group">
              <label htmlFor="pinterest_url">
                <FaPinterest style={{ marginRight: "8px", color: "#BD081C" }} />
                Pinterest URL
              </label>
              <input
                type="url"
                id="pinterest_url"
                name="social_accounts.pinterest_url"
                value={formData.social_accounts.pinterest_url}
                onChange={handleChange}
                placeholder="Enter Pinterest URL"
              />
            </div>

            <div className="form-group">
              <label htmlFor="youtube_url">
                <FaYoutube style={{ marginRight: "8px", color: "#FF0000" }} />
                Youtube URL
              </label>
              <input
                type="url"
                id="youtube_url"
                name="social_accounts.youtube_url"
                value={formData.social_accounts.youtube_url}
                onChange={handleChange}
                placeholder="Youtube URL"
              />
            </div>
          </div>
        </div>

        {/* Hours */}
        <div className="form-section-hours">
          <h2>Business Hours</h2>
          <div className="form-group custom-checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.business_time.is_24_7}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    business_time: {
                      ...prev.business_time,
                      is_24_7: e.target.checked,
                    },
                  }))
                }
              />
              Open 24/7
            </label>
          </div>

          {!formData.business_time.is_24_7 &&
            Object.keys(formData.business_time.working_hours).map((day) => (
              <div className="form-group" key={day}>
                <label>{day}</label>
                <div>
                  <input
                    type="time"
                    value={formData.business_time.working_hours[day].open}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        business_time: {
                          ...prev.business_time,
                          working_hours: {
                            ...prev.business_time.working_hours,
                            [day]: {
                              ...prev.business_time.working_hours[day],
                              open: e.target.value,
                            },
                          },
                        },
                      }))
                    }
                  />
                  <input
                    type="time"
                    value={formData.business_time.working_hours[day].close}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        business_time: {
                          ...prev.business_time,
                          working_hours: {
                            ...prev.business_time.working_hours,
                            [day]: {
                              ...prev.business_time.working_hours[day],
                              close: e.target.value,
                            },
                          },
                        },
                      }))
                    }
                  />
                </div>
              </div>
            ))}
        </div>

        <Button
          type="primary"
          htmlType="submit"
          className="submit-button"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Submit Listing
        </Button>
      </form>
    </div>
  );
};

export default AddListing;
